export default function ClearwaterLocalAreaSection() {
  return (
    <section id="service-area" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          {/* Text Content */}
          <div>
            <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
              Service Area
            </span>
            <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-6">
              Passport Services for Clearwater, Pinellas County, and Tampa Bay Beach Communities
            </h2>

            <div className="space-y-5 text-gray-700 text-sm md:text-base leading-relaxed">
              <p>
                <strong className="text-[#1A365D]">Clearwater sits on the Gulf of Mexico in Pinellas County</strong>,
                home to Clearwater Beach — repeatedly voted America's #1 Beach by TripAdvisor. With its
                powder-white sand, brilliant turquoise waters, and the iconic Pier 60 sunset celebration,
                Clearwater draws millions of visitors annually. From downtown's Coachman Park to the
                resort corridor along Gulf Boulevard, this is a community built on travel — beach vacations,
                spring break getaways, cruise departures, and snowbird migrations.
              </p>

              <p>
                <strong className="text-[#1A365D]">Two major airports serve Clearwater travelers.</strong>
                Tampa International Airport (TPA) is just 20 miles east and offers direct international flights
                to London, Frankfurt, Zurich, Cancun, and beyond. St. Pete-Clearwater International Airport (PIE),
                only 10 miles south in Pinellas County, is a major Allegiant Air hub with ultra-low-cost flights
                to dozens of domestic destinations — a favorite for budget-conscious families and snowbirds
                connecting to international gateways.
              </p>

              <p>
                <strong className="text-[#1A365D]">Spring training is a local obsession.</strong>
                The Philadelphia Phillies train at Spectrum Field (formerly Bright House Field) in downtown
                Clearwater every February and March. Just north in Dunedin, the Toronto Blue Jays hold their
                spring camp at TD Ballpark. Baseball fans from across North America flock here — many heading
                north afterward to Toronto for regular-season games, making passport readiness essential.
              </p>

              <p>
                <strong className="text-[#1A365D]">The Clearwater Marine Aquarium</strong> draws families
                from around the world to visit Winter the dolphin, star of the "Dolphin Tale" films. Nearby,
                Honeymoon Island and Caladesi Island State Park offer unspoiled Gulf beaches accessible only
                by ferry or kayak. Frenchy's Rockaway Grill and the bustling BeachWalk promenade make Clearwater
                Beach a destination in itself — but most residents know the real luxury is being able to leave
                for equally stunning shores abroad.
              </p>

              <p>
                <strong className="text-[#1A365D]">The surrounding communities</strong> — Dunedin with its
                Scottish heritage and waterfront Main Street, Palm Harbor with its golf communities along the
                Intracoastal, Safety Harbor with its natural mineral springs and charming downtown — all share
                Pinellas County's travel DNA. Clearwater Threshers minor league games at Spectrum Field,
                parasailing off Pier 60, deep-sea fishing charters from the Clearwater Marina, and dolphin
                watch cruises fill the calendar. When it's time to trade the Gulf for the Caribbean, Europe,
                or a Canadian summer, our expedited passport service keeps Clearwater moving.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                { label: "County", value: "Pinellas" },
                { label: "Nearest Intl. Airport", value: "Tampa International (TPA)" },
                { label: "Budget Air Hub", value: "St. Pete-Clearwater (PIE)" },
                { label: "Cruise Port", value: "Port of Tampa (~25 mi)" },
                { label: "Spring Training", value: "Phillies (Spectrum Field)" },
                { label: "Top Beach", value: "Clearwater Beach (#1 USA)" },
              ].map((stat, i) => (
                <div key={i} className="bg-[#F8F9FB] rounded-lg p-4">
                  <p className="text-gray-500 text-xs uppercase tracking-wider mb-1">{stat.label}</p>
                  <p className="text-[#1A365D] font-bold text-sm">{stat.value}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Clearwater+Beach+Florida+at+sunset+with+Pier+60+silhouette%2C+white+sand+and+gentle+turquoise+waves%2C+beach+umbrellas+and+walkers+along+the+shore%2C+warm+golden+orange+and+pink+sky+colors%2C+serene+Gulf+of+Mexico+coastal+scene%2C+professional+landscape+photography%2C+no+text+no+logos"
              alt="Clearwater Beach sunset with Pier 60 and white sand shoreline"
              className="w-full h-auto rounded-lg object-cover"
              width={600}
              height={800}
            />
            <div className="mt-4 bg-[#1A365D] text-white rounded-lg p-5">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 rounded-full bg-[#F6C344] flex items-center justify-center shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-sm"></i>
                </div>
                <div>
                  <p className="font-bold text-sm">Fast Passport Center — Tampa (Nearest Office)</p>
                  <p className="text-white/60 text-xs mt-0.5">400 N Ashley Dr #1700, Tampa, FL 33602</p>
                </div>
              </div>
              <p className="text-white/70 text-xs mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1"></i>
                Nearest office to Clearwater — approximately 25 miles east via US-60 / Veterans Expressway
              </p>
              <p className="text-white/50 text-xs mb-4 ml-4">Courier pickup available throughout Pinellas County</p>
              <div className="border-t border-white/10 pt-4">
                <p className="font-semibold text-sm mb-1">Service Coverage</p>
                <p className="text-white/70 text-xs leading-relaxed">
                  We serve Clearwater, Clearwater Beach, Island Estates, Dunedin, Palm Harbor, Safety Harbor,
                  Largo, Belleair, Indian Rocks Beach, and all Pinellas County communities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}